import styled from 'styled-components'

const StyledFooter = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
`

export default StyledFooter
